module.exports = __webpack_public_path__ + "sprite/win-sign.png";


//////////////////
// WEBPACK FOOTER
// ./sprite/win-sign.png
// module id = 118
// module chunks = 3